import {Rect, Vec2} from "../ThreeJS/VectorStructs.js";

export function CopyImageData(context: CanvasRenderingContext2D, sourceImageData: ImageData) {
	const imageDataCopy = context.createImageData(sourceImageData.width, sourceImageData.height);
	imageDataCopy.data.set(sourceImageData.data);
	return imageDataCopy;
}

export function ResizeBase64Image(base64ImageStr: string, scaleOrScaleGetter: number | ((oldWidth: number, oldHeight: number)=>number), quality: number, format = "webp" as "webp" | "jpeg") {
	return new Promise<string>((resolve, reject)=>{
		const img = new Image();
		img.onload = ()=>{
			const oldWidth = img.width;
			const oldHeight = img.height;

			const scale = scaleOrScaleGetter instanceof Function ? scaleOrScaleGetter(oldWidth, oldHeight) : scaleOrScaleGetter;
			const newWidth = Math.round(oldWidth * scale);
			const newHeight = Math.round(oldHeight * scale);

			// Create a canvas with the desired dimensions
			const canvas = document.createElement("canvas");
			canvas.width = newWidth;
			canvas.height = newHeight;

			// Draw the image onto the canvas
			const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
			ctx.drawImage(img, 0, 0, newWidth, newHeight);

			// Convert the canvas back to base64
			const resizedBase64 = canvas.toDataURL(`image/${format}`, quality);
			resolve(resizedBase64);
		};
		img.onerror = error=>reject(new Error(`Error loading image: ${error}`));
		img.src = base64ImageStr;
	});
}

export function FitSourceSizeIntoContainerSize(sourceSize: Vec2, containerSize: Vec2, allowScaleUp = false) {
	const scalesToFit = new Vec2(containerSize.x / sourceSize.x, containerSize.y / sourceSize.y);
	let scaleToFit = Math.min(scalesToFit.x, scalesToFit.y);
	if (!allowScaleUp) {
		scaleToFit = scaleToFit.KeepAtMost(1);
	}
	const videoSize_rescaledToFit = sourceSize.Times(scaleToFit);

	const gapArea = containerSize.Minus(videoSize_rescaledToFit);
	return new Rect(gapArea.x / 2, gapArea.y / 2, videoSize_rescaledToFit.x, videoSize_rescaledToFit.y, false);
}
/*export function DrawImage_Fit(context: CanvasRenderingContext2D, imageOrVideo: HTMLImageElement|HTMLVideoElement, targetRect: VRect, allowScaleUp = false) {
	const imageOrVideoSize = imageOrVideo instanceof HTMLImageElement
		? new Vec2(imageOrVideo.width, imageOrVideo.height)
		: new Vec2(imageOrVideo.videoWidth, imageOrVideo.videoHeight);
	const drawRect = FitSourceSizeIntoContainerSize(imageOrVideoSize, targetRect.Size, allowScaleUp).NewPosition(pos=>pos.Plus(targetRect.Position));
	context.drawImage(imageOrVideo,
		0, 0, imageOrVideoSize.x, imageOrVideoSize.y,
		drawRect.x, drawRect.y, drawRect.width, drawRect.height);
}*/

export async function GetLastFrameFromVideoBlob(blob: Blob, rescale = 1): Promise<string> {
	return new Promise((resolve, reject)=>{
		const video = document.createElement("video");
		video.preload = "metadata";
		video.muted = true;
		video.onerror = e=>{
			URL.revokeObjectURL(url);
			reject(new Error("Error loading video"));
		};
		video.onloadedmetadata = ()=>{
			// Seek to the last frame (slightly before the end for safety)
			video.currentTime = video.duration - 0.001;
		};

		// Create object URL from blob
		const url = URL.createObjectURL(blob);
		video.src = url;

		video.onseeked = ()=>{
			const dataUrl = GetCurrentFrameFromVideoPlayer(video, rescale);
			resolve(dataUrl);
		};
	});
}
export function GetCurrentFrameFromVideoPlayer(videoPlayer: HTMLVideoElement, rescale = 1): string {
	const canvas = document.createElement("canvas");
	const ctx = canvas.getContext("2d")!;
	// Set canvas dimensions to match video (scaled)
	canvas.width = Math.round(videoPlayer.videoWidth * rescale);
	canvas.height = Math.round(videoPlayer.videoHeight * rescale);

	// Draw the current frame to canvas
	ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);

	// Convert to blob or data URL
	/*canvas.toBlob(imageBlob=>{
		resolve(imageBlob);
	}, "image/png");*/

	// Or get as data URL:
	const dataUrl = canvas.toDataURL("image/png");
	return dataUrl;
}